export { FolderOpen as default } from './FolderOpen';
